const componentsComboboxDeviceCatalogComboboxEn = {
  searchCatalogPlaceholder: 'Search device catalog',
};

export default componentsComboboxDeviceCatalogComboboxEn;
